"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CategoryListItem = CategoryListItem;
exports.PanelListItem = exports.PanelListAnchor = exports.PanelList = exports.ListItem = exports.DescriptiveText = void 0;
exports.PrimaryNavTrayPanelList = PrimaryNavTrayPanelList;
exports.PrimaryNavTrayPanelListItem = PrimaryNavTrayPanelListItem;
exports.panelListTitle = exports.Top = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _react2 = require("@linaria/react");
var _core = require("@linaria/core");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _tag = _interopRequireDefault(require("@site/pattern-library-core/tag"));
var _icons = _interopRequireWildcard(require("./icons.js"));
var _breakpoints = require("@site/pattern-library-utils/breakpoints");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _icon = require("@site/pattern-library-utils/icon");
var _intentsConfig = _interopRequireDefault(require("../intents.config.js"));
var _text = _interopRequireDefault(require("@ux/text"));
var _tracking = _interopRequireDefault(require("@site/pattern-library-utils/tracking"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const PanelList = exports.PanelList = /*#__PURE__*/(0, _react2.styled)("ul")({
  name: "PanelList",
  class: "pl-p1aybaca",
  vars: {
    "p1aybaca-0": [({
      isOpen
    }) => isOpen ? '1' : '0']
  }
});
const panelListTitle = exports.panelListTitle = "pl-p1263ljn";
const PanelListItem = exports.PanelListItem = /*#__PURE__*/(0, _react2.styled)("li")({
  name: "PanelListItem",
  class: "pl-prkaso"
});
const CategoryIconWrapper = /*#__PURE__*/(0, _react2.styled)("span")({
  name: "CategoryIconWrapper",
  class: "pl-c17zgy2w"
});
const ListItem = exports.ListItem = /*#__PURE__*/(0, _react2.styled)("span")({
  name: "ListItem",
  class: "pl-ly9402x",
  vars: {
    "ly9402x-1": [({
      hasDesc
    }) => hasDesc ? 'flex-start' : 'center']
  }
});
const Top = exports.Top = /*#__PURE__*/(0, _react2.styled)("span")({
  name: "Top",
  class: "pl-t184fzfo"
});
const DescriptiveText = exports.DescriptiveText = /*#__PURE__*/(0, _react2.styled)("p")({
  name: "DescriptiveText",
  class: "pl-d1kv523p"
});
const PanelListAnchor = exports.PanelListAnchor = /*#__PURE__*/(0, _react2.styled)("a")({
  name: "PanelListAnchor",
  class: "pl-p1yxuuwm"
});

/**
 * Category List Item component.
 *
 * @param {Object} props React props
 * @param {string} props.categoryText text string
 * @param {string} props.categoryHref Href string
 * @param {string} props.categoryTrackingName Tracking name
 * @param {boolean} props.categoryHrefArrow Arrow Icon Toggle
 * @returns {React.ReactElement} Primary Nav Tray Panel List Item
 * @public
 */
function CategoryListItem({
  categoryHref,
  categoryText,
  categoryTrackingName,
  categoryHrefArrow = true
}) {
  return /*#__PURE__*/_react.default.createElement(PanelListItem, {
    "data-cy": "primary-nav-tray-panel-list-item"
  }, /*#__PURE__*/_react.default.createElement(ListItem, {
    "data-cy": "list-item",
    iconsExist: categoryHrefArrow
  }, categoryHrefArrow && /*#__PURE__*/_react.default.createElement(CategoryIconWrapper, {
    "data-cy": "arrow-icon",
    style: {
      gridColumn: 'icon'
    }
  }, /*#__PURE__*/_react.default.createElement(_icon.Icon, {
    name: "arrow-right",
    className: _icons.NavIcon,
    fill: _intentsConfig.default.ux.box.foregroundColor
  })), /*#__PURE__*/_react.default.createElement(PanelListAnchor, (0, _extends2.default)({
    "data-cy": "optional-panel-list-anchor",
    href: categoryHref,
    style: {
      gridColumn: categoryHrefArrow ? 'text' : 'icon / end'
    }
  }, _tracking.default.create(categoryTrackingName, true, false)), categoryText)));
}
CategoryListItem.propTypes = {
  categoryHref: _propTypes.default.string,
  categoryText: _propTypes.default.string,
  categoryTrackingName: _propTypes.default.string,
  categoryHrefArrow: _propTypes.default.bool
};

/**
 * Primary Nav Tray Panel List Item component.
 *
 * @param {Object} props React props
 * @param {string} props._name name for tracking
 * @param {string} props.text text string
 * @param {string} props.href Href string
 * @param {string} props.icon Icon string
 * @param {string} props.descriptiveText Descriptive Text string
 * @returns {React.ReactElement} Primary Nav Tray Panel List Item
 * @public
 */
function PrimaryNavTrayPanelListItem({
  _name,
  text: anchorText,
  href,
  icon,
  descriptiveText,
  tag,
  iconsExist
}) {
  return /*#__PURE__*/_react.default.createElement(PanelListItem, {
    "data-cy": "primary-nav-tray-panel-list-item"
  }, href ? /*#__PURE__*/_react.default.createElement(ListItem, {
    "data-cy": "list-item",
    hasDesc: !!descriptiveText,
    iconsExist: iconsExist
  }, icon && /*#__PURE__*/_react.default.createElement(_icons.default, {
    icon: icon,
    "data-cy": "icon-column",
    style: {
      gridColumn: 'icon'
    }
  }), /*#__PURE__*/_react.default.createElement("div", {
    "data-cy": "text-column",
    style: {
      gridColumn: iconsExist ? 'text' : 'icon / end'
    }
  }, /*#__PURE__*/_react.default.createElement(Top, null, /*#__PURE__*/_react.default.createElement(PanelListAnchor, (0, _extends2.default)({
    "data-cy": "optional-panel-list-anchor",
    href: href
  }, _tracking.default.create(_name, true, false)), anchorText), tag && /*#__PURE__*/_react.default.createElement(_tag.default, {
    text: tag.text,
    design: "inline",
    emphasis: tag.emphasis,
    size: "sm"
  })), descriptiveText && /*#__PURE__*/_react.default.createElement(DescriptiveText, null, descriptiveText))) : {
    text: _text.default
  });
}
PrimaryNavTrayPanelListItem.propTypes = {
  _name: _propTypes.default.string,
  text: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]),
  href: _propTypes.default.string,
  icon: _propTypes.default.string,
  descriptiveText: _propTypes.default.string,
  tag: _propTypes.default.shape(_tag.default.propTypes),
  iconsExist: _propTypes.default.bool
};

/**
 * Primary Nav Tray Panel List component.
 *
 * @param {Object} props React props
 * @param {string} props._name Name for tracking
 * @param {string} props.title Title
 * @param {string} props.titleHref Href for title
 * @param {boolean} props.categoryHrefArrow Arrow Icon Toggle
 * @param {array} props.menuItems menu items
 * @returns {React.ReactElement} Primary Nav Tray Panel List
 * @public
 */
function PrimaryNavTrayPanelList({
  title,
  menuItems,
  categoryText,
  categoryHref,
  categoryHrefArrow = true,
  categoryTrackingName,
  isOpen
}) {
  const [iconExistInArray, setIconExistInArray] = _react.default.useState(false);
  _react.default.useEffect(() => {
    const hasIcon = menuItems?.some(item => item.icon);
    setIconExistInArray(hasIcon);
  }, [menuItems]);
  return /*#__PURE__*/_react.default.createElement(PanelList, {
    "data-cy": "primary-nav-tray-panel-list",
    isOpen: isOpen
  }, /*#__PURE__*/_react.default.createElement(_text.default.li, {
    className: `text-uppercase ${panelListTitle} ${!title ? 'hide' : ''}`,
    as: "caption",
    text: title
  }), menuItems?.map(({
    _name,
    title: menuTitle,
    descriptiveText,
    icon,
    href,
    tag
  }, i) => /*#__PURE__*/_react.default.createElement(PrimaryNavTrayPanelListItem, {
    key: i,
    _name: _name,
    text: menuTitle,
    descriptiveText: descriptiveText,
    icon: icon,
    href: href,
    tag: tag,
    iconsExist: iconExistInArray
  })), categoryText && categoryHref && /*#__PURE__*/_react.default.createElement(CategoryListItem, {
    categoryText: categoryText,
    categoryHref: categoryHref,
    categoryTrackingName: categoryTrackingName,
    categoryHrefArrow: categoryHrefArrow
  }));
}
PrimaryNavTrayPanelList.propTypes = {
  title: _propTypes.default.string,
  menuItems: _propTypes.default.array,
  categoryText: _propTypes.default.string,
  categoryHref: _propTypes.default.string,
  categoryTrackingName: _propTypes.default.string,
  categoryHrefArrow: _propTypes.default.bool,
  isOpen: _propTypes.default.bool
};